import { createFileRoute, redirect } from "@tanstack/react-router";

// The short link from Share and the printed QR code. A platform session's
// results never move, so it keeps the 301. A session taken on a coach page
// goes to that coach's results only while the page is on, so it gets a 302
// that browsers do not keep.
export const Route = createFileRoute("/_public/w/$id")({
  loader: async ({ params }) => {
    const { getWheelSessionFn } = await import("~/lib/functions/wheel");
    const row = await getWheelSessionFn({ data: { id: params.id } });
    if (row?.coachUsername) {
      throw redirect({
        to: "/$username/wheel-of-life/results/$id",
        params: { username: row.coachUsername, id: params.id },
        statusCode: 302,
      });
    }
    throw redirect({
      to: "/wheel-of-life/results/$id",
      params: { id: params.id },
      search: { claim: undefined },
      statusCode: row?.isCoachSession ? 302 : 301,
    });
  },
});
